var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_87-js"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 459.998,
    style: {
      fill: "#F0DB4F"
    },
    width: 459.996,
    x: 26.002,
    y: 26.001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.331,384.759c0,44.767-26.286,65.2-64.586,65.2c-34.601,0-54.623-17.865-64.892-39.529    l35.218-21.255c6.777,12.013,12.938,22.177,27.826,22.177c14.169,0,23.207-5.544,23.207-27.208V237.21h43.227V384.759    L276.331,384.759z",
    style: {
      fill: "#323330"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.598,449.959c-40.147,0-66.124-19.099-78.754-44.151l35.219-20.332    c9.241,15.095,21.356,26.286,42.611,26.286c17.866,0,29.364-8.932,29.364-21.355c0-14.787-11.704-20.021-31.52-28.75l-10.781-4.62    c-31.214-13.246-51.853-29.983-51.853-65.2c0-32.447,24.745-57.09,63.248-57.09c27.518,0,47.232,9.549,61.402,34.603    l-33.679,21.562c-7.392-13.246-15.401-18.481-27.825-18.481c-12.63,0-20.639,8.01-20.639,18.481    c0,12.938,8.009,18.176,26.594,26.285l10.78,4.621c36.759,15.71,57.397,31.832,57.397,67.974    C450.164,428.602,419.565,449.959,378.598,449.959L378.598,449.959z",
    style: {
      fill: "#323330"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.90384b2de06d28553533ed9bb6d606bf.svg";
export { ForwardRef as ReactComponent };